import { CornerTicks, Reveal, SectionHeading } from "./decor";
import { ASSETS, SOUND_BADGES } from "../data/siteData";
import { useLang } from "../i18n";

export const History = () => {
  const { t } = useLang();
  return (
    <section id="history" data-testid="history-section" className="relative py-24 sm:py-32 bg-[#0A0A0C]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeading kicker={t.history.kicker} title={t.history.title} testId="history-heading" />

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <Reveal className="relative">
            <div className="absolute -top-3 -left-3 w-full h-full border border-red-600/40" />
            <div className="relative overflow-hidden">
              <img
                src={ASSETS.portraitBW}
                alt="CRAYFOX band portrait"
                className="w-full h-[420px] sm:h-[540px] object-cover grayscale contrast-125 hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              <CornerTicks />
            </div>
          </Reveal>

          <div>
            <Reveal delay={0.1}>
              <p className="text-base sm:text-lg text-zinc-300 leading-relaxed">{t.history.p1}</p>
              <p className="mt-5 text-base sm:text-lg text-zinc-400 leading-relaxed">{t.history.p2}</p>
            </Reveal>

            <Reveal delay={0.15} className="mt-10">
              <div className="border-l-2 border-red-600 pl-5 py-1">
                <p className="text-lg sm:text-xl text-zinc-200 italic leading-relaxed">{t.history.quote}</p>
                <p className="mt-2 font-mono-tech text-xs tracking-[0.25em] text-zinc-500 uppercase">
                  {t.history.quoteBy}
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.2} className="mt-10 flex flex-wrap gap-2">
              {SOUND_BADGES.map((b) => (
                <span
                  key={b}
                  className="font-mono-tech text-xs tracking-[0.15em] uppercase border border-zinc-700 text-zinc-300 px-3 py-1.5 hover:border-red-600 hover:text-red-500 transition-colors duration-300"
                >
                  {b}
                </span>
              ))}
            </Reveal>
          </div>
        </div>

        <div className="mt-20 grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-zinc-800 border border-zinc-800">
          {t.history.timeline.map((item, i) => (
            <Reveal key={item.year} delay={i * 0.08} className="bg-[#121216] p-6 hover:bg-[#18181F] transition-colors duration-300">
              <p className="font-display text-4xl text-red-600">{item.year}</p>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{item.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
